import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column" }
const _hoisted_2 = { class: "kn-flex" }
const _hoisted_3 = { class: "kn-flex p-d-flex p-flex-row p-justify-center" }
const _hoisted_4 = { style: {"position":"relative","height":"20rem","width":"20rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Chart = _resolveComponent("Chart")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.cacheManagement.runtimeInformationTitle')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-refresh",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.refresh
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("p", null, _toDisplayString(_ctx.$t('managers.cacheManagement.cacheEnabled')) + ": " + _toDisplayString(_ctx.cache.cleaningEnabled), 1),
          _createVNode("p", null, _toDisplayString(_ctx.$t('managers.cacheManagement.totalMemory')) + ": " + _toDisplayString(_ctx.totalMemory), 1),
          _createVNode("p", null, _toDisplayString(_ctx.$t('managers.cacheManagement.availableMemory')) + ": " + _toDisplayString(_ctx.availableMemory), 1),
          _createVNode("p", null, _toDisplayString(_ctx.$t('managers.cacheManagement.numberOfCachedObjects')) + ": " + _toDisplayString(_ctx.cache.cachedObjectsCount), 1),
          _createVNode("p", null, _toDisplayString(_ctx.$t('managers.cacheManagement.availableMemoryPercentage')) + ": " + _toDisplayString(_ctx.cache.availableMemoryPercentage) + "%", 1)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Chart, {
              type: "pie",
              data: _ctx.cacheData,
              "data-test": "chart"
            }, null, 8, ["data"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}